
































import { Component, Mixins, Model, Prop, Emit } from "vue-property-decorator";
import { FormatReference, FormatSet } from "../../../domain/format";
import { Patient } from "../../../domain/patient";
import {
  PatientSpecifiedHeaderPane,
  RightSidePane,
  NavigationPane,
} from "../../panes";
import FormatListViewer from "../../format/viewers/FormatListViewer.vue";
import { IFormatTreeSourceFilterable } from "../../format/selectors/trees/sources";

@Component({
  components: {
    PatientSpecifiedHeaderPane,
    RightSidePane,
    NavigationPane,
    FormatListViewer,
  }
})
export default class NewDocumentFormatSelector extends Mixins() {
  @Model("input")
  value: FormatReference;

  @Prop({ default: false })
  isEmbedded: boolean;

  @Prop()
  patient: Patient;

  @Prop()
  formatId: number;

  @Prop()
  formatIds: number[];

  @Prop({ default: null })
  formatName: string;

  @Prop()
  formatTreeSourceFilter: IFormatTreeSourceFilterable;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  enableFormatSetTabs: boolean;

  @Prop({ default: true })
  shouldShowPatientInformation: boolean;

  data(): any {
    return {
      selectedFormat: this.value, // valueも単方向データフローを守らないとwarningが出る.
      selectedFormatSet: null,
    };
  }
  selectedFormat: FormatReference;
  selectedFormatSet: FormatSet;

  get visibleTabs(): any[] {
    const tabs = this.enableFormatSetTabs
      ? FormatListViewer.allTabs
      : FormatListViewer.formatTabs;
    return tabs.filter(t => this.isVisibleTab(t));
  }

  private isVisibleTab(tab: any): boolean {
    if (!tab) { return false; }
    // 全科頻用・科頻用・個人頻用はFormatsSelectorで判定している
    // 検索条件としてフォーマット選択するときは「すべて」が表示できたほうが良いため、allだけはここで判定している
    return tab.keyword !== "all" || this.$configuration.behavior.format.selector.tab.all.isEnable;
  }

  get isSelected(): boolean {
    return this.isFormatSelected || this.isAvailableFormatSetSelected;
  }
  
  get isFormatSelected(): boolean {
    // だいぶ苦しい対応しているので余裕が出来たら見直したい
    return !!this.selectedFormat && !this.isFormatSetSelected;
  }

  get isFormatSetSelected(): boolean {
    return this.enableFormatSetTabs && !!this.selectedFormatSet;
  }

  get isAvailableFormatSetSelected(): boolean {
    return (this.isFormatSetSelected && this.selectedFormatSet.formats.some(f => !f.deleted && !f.expired));
  }

  @Emit()
  input(value: FormatReference): any {}

  @Emit()
  select(value: FormatReference): any {}

  emit() {
    // 現状ではこれで判定できているが、どのタブが選択されているかで制御したいところではある
    if (this.isFormatSetSelected) {
      this.onFormatSetDoubleClicked();
    } else {
      this.input(this.selectedFormat);
      this.select(this.selectedFormat);
    }
  }

  @Emit("formatSetSelectionChanged")
  onFormatSetSelectionChanged(value: FormatSet): void {
    // だいぶ苦しい対応しているので余裕が出来たら見直したい
    this.selectedFormatSet = value;
  }

  @Emit("formatSetDoubleClicked")
  onFormatSetDoubleClicked(): void {}

  get isReady(): boolean {
    return true;  // 固まって患者番号入力できなかった時の暫定対応実装.解決したので常にreadyとする.
  }
}
